import { checkUserPermissions } from '@/components/Auth/checkUserPermissions';
import { createFileRoute, redirect, Navigate } from '@tanstack/react-router';
import { getDefaultView } from '@/utils/viewHelpers';
import { DocumentHead } from '@/components/core/DocumentHead';

export const Route = createFileRoute(
  '/$tenantId/_layout/organizations/organization/$organizationId/',
)({
  component: OrganizationRedirect,
  beforeLoad: ({ params }) => {
    const hasPermission = checkUserPermissions({
      permission: 'tenant:viewer',
    });
    if (!hasPermission) {
      throw redirect({ to: '/$tenantId', params });
    }
  },
});

function OrganizationRedirect() {
  const { tenantId, organizationId } = Route.useParams();
  const view = getDefaultView('organization');

  return (
    <>
      <DocumentHead
        titleKey="page.organization.details.title"
        descriptionKey="page.organization.details.description"
        resetOnUnmount={false}
      />
      <Navigate
        to="/$tenantId/organizations/organization/$organizationId/$view"
        params={{ tenantId, organizationId, view }}
        replace
      />
    </>
  );
}
